window.SMTX.LocaleSuggest = (async function () {

  var $_mainNav = $('.top-menu');
  var $_localeSuggest = $('#locale_suggest');
  var $_localeText = $('#locale_suggest [data-text]');
  var $_localeBtn = $('#locale_suggest [data-continue]');
  var _containerHeight = 0;
  var _supportedLangs = [/*'en',*/ 'sv', 'nb', 'da', 'fi', 'de']; // should not 
  var _availableSupportedLangs = await filterSupportedLangs();
  var _currentLang = $('html').attr('lang').slice(0, 2); // eg from sv-SE to sv
  var _userLang = navigator.language || navigator.userLanguage;
  _userLang = _userLang.slice(0, 2);
  

  if(_currentLang === _userLang || _currentLang !== 'en'){
    //log('no locale need');
    return false;
  }else if( !hasLangSupport() ){
    //log('no locale support for ' + _userLang);
  } else {
    if(window.SMTX.localeInfo) {
      //log('show locale suggest for/in ' + _userLang);
      $_mainNav.addClass('has-locale-suggest');
      $('#locale_suggest select option[data-lang="' + _userLang + '"]').prop('selected', true);
      $_localeText.text(  window.SMTX.localeInfo[_userLang].text );
      $_localeBtn.text(  window.SMTX.localeInfo[_userLang].button_label );
      $_localeSuggest.show();
    }
  }

  $(document).on('click', "#locale_suggest .close", function() {
    $_localeSuggest.remove();
    $_mainNav.removeClass('has-locale-suggest');
    $('.nav-spacer').css('height',  '');
    $('#global_alerts').css('top',  '');
    $_mainNav.css('height', '');
    
  });

  $(document).on('click', "#locale_suggest [data-continue]", function() {
    window.location.href = $('#locale_suggest select').val();
  });


  $(window).on('resize', function(){
    if( $_mainNav.hasClass('has-locale-suggest') ){
     
      $('.nav-spacer').css('height',  '');
      $_mainNav.css('height', '');
      var hh = $('.top-menu-grid').height() + $('#locale_suggest').height();
      $_mainNav.css('height', hh);
     
      if( $('.nav-spacer').hasClass('has-hero') ){
        $('.nav-spacer').css('height',  $('#locale_suggest').height());
        $('#global_alerts').css('top',  $('.top-menu-grid').height());
      }else{
        $('.nav-spacer').css('height', hh);
        $('#global_alerts').css('top',  '0');
      }
    }
  });

  $(window).trigger('resize');
  
  function filterSupportedLangs(){
    
    return fetch('/actions/guest-access-control/guest-access-control/get-hidden-site')
      .then((response) => response.json())
      .then(({ hiddenSite }) => {
        const { lang: hiddenLang } = hiddenSite;
        
        if (hiddenLang && _supportedLangs.includes(hiddenLang)) {
          return _supportedLangs.filter((lang) => lang !== hiddenLang);
        }

        return _supportedLangs;
      });
  }

  function hasLangSupport(){
    return _availableSupportedLangs.includes(_userLang);
  }

  return {

  };

})();
